import React, { useEffect, useMemo, useState } from 'react';
import { useHeaderContext } from '../Context/HeaderContext';
import { Transition } from '@headlessui/react';
import agregarComplementoPedido from '../Utils/agregarComplemento'

import { useAgregarPedido } from '../Utils/useAgregarPedido';
import { calcularDiasHabilesFinales, obtenerFechaActualPeru } from '../Utils/obtenerFechaActualPeru';

import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import Swal from 'sweetalert2'
import calculartotal from '../Utils/calcularTotal';
import { confirmCanjePuntos } from '../Utils/buildPuntosModalHtml';


const noSelectStyle = {
  userSelect: 'none',
  WebkitUserDrag: 'none',
};

export default function CartModal() {
  const {
    auth,
    isCartOpen,
    setIsCartOpen,
    cartItems,
    totalPrice,
    setCartItems,
    deleteItem,
    addOnCarBtn,
    deleteOnCarBtn,
    // Catálogo/Sugerencias de Upselling
    upsellCatalog,
    userPoints,
    setDetallePedido,
  } = useHeaderContext();



  const { agregarPedido } = useAgregarPedido();

  const onClose = () => {
    setIsCartOpen(false);
  };
  const [upsellCatalogoFiltered, setUpsellCatalogoFiltered] = useState([])

  const tieneComplementos = cartItems.some(item => item.tipo === "Complemento") || cartItems.some(item => item.tipo === "Chica");

  useEffect(() => {

    // 1. Convertimos la fecha del carrito a un objeto Date (a medianoche para comparar solo fechas)
    if (cartItems.length == 0 || upsellCatalog == undefined) return
    const [year, month, day] = cartItems[0].fecha.split('-').map(Number);
    const fechaEntregaCarrito = new Date(year, month - 1, day);

    // 2. Obtenemos el inicio del día actual (Hoy a las 00:00:00)
    const hoy = new Date();
    hoy.setHours(0, 0, 0, 0);

    const upsellingFiltered = upsellCatalog.filter(producto => {
      // Si el producto no tiene categorías, asumimos 0 días de preparación
      if (!producto.categories_many || producto.categories_many.length === 0) {
        return true;
      }

      // Obtenemos los días necesarios tomando la categoría más restrictiva (mayor número de días)
      const diasRequeridos = Math.max(
        ...producto.categories_many.map(cat => calcularDiasHabilesFinales(cat))
      );

      // Si no requiere días adicionales, se puede entregar de inmediato
      if (diasRequeridos === 0) {
        return true;
      }

      // Calculamos la fecha mínima en la que este producto estaría listo
      const fechaMinimaEntrega = new Date(hoy);

      fechaMinimaEntrega.setDate(fechaMinimaEntrega.getDate() + diasRequeridos);


      // El producto se muestra si la fecha del carrito es IGUAL o POSTERIOR a la fecha mínima
      return fechaEntregaCarrito >= fechaMinimaEntrega;
    });

    setUpsellCatalogoFiltered(upsellingFiltered)

  }, [upsellCatalog]);

  // Verificar si existe solo complementos en el carrito
  const hasOnlyComplements = useMemo(() => {
    if (cartItems.length === 0) return false;
    return cartItems.every(
      (item) => item.tipo === 'Complemento' || item.isComplement || item.categoria === 'Complemento'
    );
  }, [cartItems]);

  // Cálculo del precio total considerando variaciones, extras y puntos
  const total = calculartotal(cartItems, auth.points)

  const handleAddUpsell = async (e, product) => {

    if (product.tipo_servicio == 'producto') {

      setDetallePedido(old => ({ ...old, opcion: product.id }))
      await agregarPedido(e)

    } else {

      await agregarComplemento(e, product.id, product)
    }



  };




  const agregarComplemento = async (e = null, id, complemento) => {

    let carrito = cartItems ?? [];

    let isConfirmed = false
    if (auth.points >= complemento.puntos_complemento && complemento.puntos_complemento > 0) {
      // Construcción del HTML (se eliminó el -m-5 del div raíz)
      isConfirmed = await confirmCanjePuntos({
        userPoints: auth.points,
        complemento: complemento
      });
    }

    // Continuar con la función pasándole si el usuario confirmó o no
    agregarComplementoPedido(cartItems, id, isConfirmed, setCartItems);

  }

  return (
    <>
      {/* Overlay transparente/oscuro */}
      <div
        className={`${isCartOpen ? 'fixed' : 'hidden'} inset-0 z-40 bg-black/40 backdrop-blur-xs transition-opacity`}
        onClick={onClose}
      />

      {/* Drawer del Carrito */}
      <Transition
        show={isCartOpen}
        enter="transition-transform ease-out duration-300"
        enterFrom="translate-x-full"
        enterTo="translate-x-0"
        leave="transition-transform ease-in duration-200"
        leaveFrom="translate-x-0"
        leaveTo="translate-x-full"
      >
        <div
          id="cart-modal"
          className="bag fixed top-0 right-0 w-[90vw] md:w-[516px] h-screen cartContainer bg-[#FFFDF1] border-l border-[#ECE4D8] shadow-2xl !rounded-none md:!rounded-l-2xl !p-0 modal z-50 overflow-hidden flex flex-col justify-between"
        >
          {/* Header */}
          <div className="flex justify-between items-center px-6 md:px-8 pt-6 pb-4 border-b border-[#ECE4D8] bg-[#FFFDF1] shrink-0">
            <h2 className="flex items-center gap-2 font-bold font-plus_jakarta text-[22px] md:text-[24px] text-[#2B211C]">
              Carrito de compras
            </h2>
            <button
              type="button"
              id="close-cart"
              onClick={onClose}
              className="w-8 h-8 rounded-full bg-[#FAF7F2] border border-[#ECE4D8] flex items-center justify-center text-[#6B5D52] hover:bg-[#EAE3D9] transition-colors focus:outline-none cursor-pointer"
              aria-label="Cerrar carrito"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="2"
                stroke="currentColor"
                className="w-4 h-4"
              >
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          {/* Contenedor Scrolleable de Items y Sugerencias */}
          <div className="flex-1 overflow-y-auto px-6 md:px-8 py-4 space-y-4 scrollbar-thin scrollbar-thumb-[#ECE4D8]">
            {cartItems.length === 0 ? (
              <div className="text-center py-16 text-gray-500 font-plus_jakarta">
                <p className="text-lg font-medium text-[#2B211C] mb-1">Tu carrito está vacío</p>
                <p className="text-sm text-[#A89A8C]">Explora nuestro catálogo para agregar hermosos detalles.</p>
              </div>
            ) : (
              (() => {
                let userRestPoints = typeof userPoints !== 'undefined' ? Number(userPoints) : 0;

                return cartItems.map((element) => {
                  let precioBase = Number(element.precio || 0);
                  let usesPointsInThisItem = false;
                  const qty = element.cantidad || 1;

                  if (element.usePoints && userRestPoints >= ((element.points || 0) * qty)) {
                    precioBase = 0;
                    userRestPoints -= ((element.points || 0) * qty);
                    usesPointsInThisItem = true;
                  }

                  const adicionalKeke = Number(element.kekeSabor?.precio_adicional || 0);
                  const adicionalRelleno = Number(element.kekeRelleno?.precio_adicional || 0);
                  const precioUnitarioFinal = precioBase + adicionalKeke + adicionalRelleno;

                  const isComplement = element.tipo === 'Complemento' || element.isComplement || element.categoria === 'Complemento';

                  const hasDedicatoria = Boolean(
                    element?.dedicatoria?.message || element?.dedicatoria?.from || element?.dedicatoria?.to
                  );

                  return (
                    <div
                      key={element.id}
                      className="bg-white border border-[#ECE4D8] rounded-2xl p-3.5 md:p-4 flex gap-3 md:gap-4 transition-all duration-200 shadow-xs hover:shadow-md"
                    >
                      {/* Imagen del Producto */}
                      <div className="shrink-0">
                        <img
                          loading="lazy"
                          src={`/img-resize/${element.imagen || element.image}?w=200&h=200`}
                          alt={`${element.producto || element.name}`}
                          className="w-[72px] h-[72px] md:w-[84px] md:h-[84px] object-cover rounded-xl bg-[#F3ECDF]"
                          style={{ userSelect: 'none', WebkitUserDrag: 'none' }}
                          onContextMenu={(e) => e.preventDefault()}
                          onError={(e) => {
                            e.currentTarget.onerror = null;
                            e.currentTarget.src = '/images/img/noimagen.jpg';
                          }}
                        />
                      </div>

                      {/* Detalles del Producto */}
                      <div className="flex flex-col flex-1 min-w-0 justify-between">
                        <div>
                          <div className="flex items-start justify-between gap-1">
                            <h3 className="text-[14px] md:text-[15px] font-bold text-[#2B211C] leading-snug truncate font-plus_jakarta">
                              {element.producto || element.name}
                            </h3>
                          </div>

                          <p className="text-[12px] text-[#A89A8C] truncate font-plus_jakarta mt-0.5">
                            {element.extract || (isComplement ? 'Complemento para tu pedido' : 'Producto principal')}
                          </p>

                          {/* Tag de Complemento */}
                          {isComplement && (
                            <div className="mt-1">
                              <span className="inline-flex items-center gap-1 bg-[#FFF1EA] text-[#D9602F] text-[10.5px] font-bold px-2.5 py-0.5 rounded-full">
                                🎁 Complemento
                              </span>
                            </div>
                          )}

                          <div className="mt-1.5 flex items-center gap-2">
                            <span className="text-[14px] md:text-[15px] font-bold text-[#2F8F5B] font-plus_jakarta">
                              S/ {(precioUnitarioFinal * qty).toFixed(2)}
                            </span>
                            {element.usePoints && (
                              <span className="text-xs bg-orange-100 text-orange-600 px-1.5 py-0.5 rounded font-medium">
                                Con puntos
                              </span>
                            )}
                          </div>
                        </div>

                        {/* Stepper y Eliminar */}
                        <div className="flex items-center justify-between mt-2 pt-2 border-t border-gray-50">
                          <div className="flex items-center gap-2">
                            <button
                              type="button"
                              onClick={() => deleteOnCarBtn ? deleteOnCarBtn(element.id , element.usePoints) : null}
                              className="w-6 h-6 rounded-md border border-[#ECE4D8] bg-white text-[#2B211C] hover:bg-gray-100 flex items-center justify-center text-sm font-bold transition-colors cursor-pointer"
                              aria-label="Disminuir cantidad"
                            >
                              −
                            </button>
                            <span className="text-sm font-semibold text-[#2B211C] min-w-[16px] text-center font-plus_jakarta">
                              {qty}
                            </span>
                            <button
                              type="button"
                              onClick={() => addOnCarBtn ? addOnCarBtn(element.id , element.usePoints) : null}
                              className="w-6 h-6 rounded-md border border-[#ECE4D8] bg-white text-[#2B211C] hover:bg-gray-100 flex items-center justify-center text-sm font-bold transition-colors cursor-pointer"
                              aria-label="Aumentar cantidad"
                            >
                              +
                            </button>
                            
                          </div>

                          <button
                            type="button"
                            onClick={() => deleteItem ? deleteItem(element.id, element.usePoints) : null}
                            className="text-[12px] text-[#A89A8C] underline hover:text-[#D9602F] transition-colors cursor-pointer"
                          >
                            Eliminar
                          </button>
                        </div>

                        {/* Bloque de Dedicatoria si existe */}
                        {hasDedicatoria && (
                          <div className="mt-2.5 p-2 bg-[#FFFDF1] border border-[#ECE4D8] rounded-lg text-[11px] text-[#6B5D52]">
                            <div className="font-semibold text-[#D9602F] mb-0.5">Dedicatoria personalizada:</div>
                            {element?.dedicatoria?.from && <div><span className="font-medium">De:</span> {element.dedicatoria.from}</div>}
                            {element?.dedicatoria?.to && <div><span className="font-medium">Para:</span> {element.dedicatoria.to}</div>}
                            {element?.dedicatoria?.message && <p className="italic mt-0.5 truncate">"{element.dedicatoria.message}"</p>}
                          </div>
                        )}
                      </div>
                    </div>
                  );
                });
              })()
            )}

            {/* Banner Informativo / Bloqueo cuando hay sólo complementos */}
            {hasOnlyComplements && (
              <div className="bg-[#FFF1EA] border border-[#FFD2BD] rounded-xl p-3.5 md:p-4 my-3 transition-all">
                <div className="flex items-start gap-3">
                  <span className="text-xl shrink-0">🎁</span>
                  <div>
                    <h4 className="font-bold text-[13.5px] text-[#7A4A2C] mb-1">
                      ¡Un paso más para tu pedido perfecto!
                    </h4>
                    <p className="text-[12.5px] text-[#8A5A3A] leading-relaxed">
                      Los complementos deben ir acompañados de un arreglo floral o una torta de nuestro catálogo para ser procesados.
                    </p>
                    <button
                      type="button"
                      onClick={() => {
                        const el = document.getElementById('upsell-suggestions-section');
                        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                      }}
                      className="mt-2 text-[#D9602F] font-bold text-[12.5px] underline hover:text-[#B84A20] transition-colors cursor-pointer"
                    >
                      Ver productos principales ↓
                    </button>
                  </div>
                </div>
              </div>
            )}


            {/* Sección de Upselling / Productos Sugeridos */}

            {(cartItems.length > 0 && !tieneComplementos) && (
              <div id="upsell-suggestions-section" className="pt-2 pb-1">
                <h4 className="text-[13px] font-bold text-[#2B211C]">
                  {hasOnlyComplements ? 'Completa tu pedido con:' : 'Agrega un detalle especial:'}
                </h4>
                <p className="text-[11.5px] text-[#A89A8C] mb-3">
                  {hasOnlyComplements
                    ? 'Elige un arreglo floral o torta para continuar'
                    : 'Complementa tu regalo con estas opciones'}
                </p>

                {upsellCatalogoFiltered.length > 0 && (
                  <Swiper
                    modules={[Autoplay]}
                    autoplay={{
                      delay: 2500,                  // Tiempo de espera entre deslizadas (2.5 segundos)
                      disableOnInteraction: true,  // Cancela el autoplay definitivamente si el usuario lo mueve/toca
                      pauseOnMouseEnter: true,     // Pausa el desplazamiento si tiene el cursor encima sin moverlo
                    }}
                    slidesPerView="auto"
                    spaceBetween={10}
                    grabCursor={true}
                    className="w-full pb-2"
                  >
                    {upsellCatalogoFiltered.map((item) => {
                      const mainImage = item.images?.[0] || item.image;
                      console.log(mainImage)

                      return (
                        <SwiperSlide key={item.id} className="!w-[150px]">
                          <div
                            onClick={(e) => handleAddUpsell(e, item)}
                            className="relative w-full h-full cursor-pointer border border-[#ECE4D8] rounded-xl p-2.5 bg-white flex flex-col justify-between shadow-2xs hover:border-[#FF8555] transition-all"
                          >
                            <div>

                              <div className="w-full aspect-[3/4] rounded-lg bg-[#F3ECDF] flex items-center justify-center overflow-hidden mb-2 relative">
                                {mainImage?.name_imagen ? (
                                  <img
                                    src={`/img-resize/${mainImage.name_imagen}?w=180&h=240`}
                                    alt={item.producto || item.name}
                                    className="w-full h-full object-cover"
                                    onError={(e) => {
                                      e.currentTarget.onerror = null;
                                      e.currentTarget.src = '/images/img/noimagen.jpg';
                                    }}
                                  />
                                ) : (
                                  <span className="text-2xl">💐</span>
                                )}
                                <button
                                  type="button"
                                  onClick={(e) => {
                                    e.stopPropagation(); // Evita doble disparo con el onClick del contenedor
                                    handleAddUpsell(e, item);
                                  }}
                                  className="absolute top-1 right-1 w-7 h-7 rounded-full bg-[#FF8555] hover:bg-[#F06B35] active:scale-95 text-white font-bold text-base flex items-center justify-center shadow-md transition-all cursor-pointer z-10"
                                  title="Agregar complemento"
                                  aria-label="Agregar complemento"
                                >
                                  +
                                </button>
                              </div>
                              <p className="text-[12px] font-bold text-[#2B211C] line-clamp-2 leading-tight min-h-[30px] font-plus_jakarta">
                                {item.producto}
                              </p>
                            </div>

                            <div className="flex items-center justify-between mt-2 pt-1 border-t border-gray-100">
                              <span className="text-[12.5px] font-bold text-[#2F8F5B]">
                                S/ {Number(item.descuento) > 0 ? item.descuento : item.precio}
                              </span>
                              {item.puntos_complemento > 0 && (
                                <div className="flex justify-start items-center gap-[5px]">
                                  <div className="h-6 w-6">
                                    <img
                                      src="/images/ux/Group 3623.png"
                                      alt=""
                                      onContextMenu={(e) => e.preventDefault()}
                                      style={noSelectStyle}
                                    />
                                  </div>

                                  <div className="w-10 h-6 justify-center text-zinc-800 text-[12.5px] font-semibold font-PlusJakartaSans_Regular">
                                    {item.puntos_complemento}pts
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </SwiperSlide>
                      );
                    })}
                  </Swiper>
                )}
              </div>
            )}
          </div>

          {/* Footer del Carrito */}
          <div className="shrink-0 border-t border-[#ECE4D8] p-5 md:px-8 bg-white">
            <div className="flex justify-between items-baseline mb-3">
              <span className="text-[14px] font-bold text-[#2B211C] font-plus_jakarta">
                Total
              </span>
              <span className="text-[20px] font-bold text-[#2F8F5B] font-plus_jakarta" id="itemsTotal">
                S/ {total.toFixed(2)}
              </span>
            </div>

            <div className="space-y-2">
              {hasOnlyComplements ? (
                <>
                  <button
                    disabled
                    className="w-full py-3.5 px-4 rounded-xl bg-[#ECE4D8] text-[#A89A8C] font-bold text-[14.5px] font-plus_jakarta cursor-not-allowed text-center transition-colors"
                  >
                    Realizar pedido
                  </button>
                  <p className="text-[11.5px] text-[#A89A8C] text-center leading-normal">
                    Agrega un arreglo floral o una torta para continuar con tu compra.
                  </p>
                </>
              ) : (
                <a
                  id="btn-realizar-pedido"
                  href={cartItems.length > 0 ? "/carrito" : "#"}
                  onClick={(e) => {
                    if (cartItems.length === 0) e.preventDefault();
                  }}
                  className={`w-full py-3.5 px-4 rounded-xl font-bold text-[14.5px] font-plus_jakarta text-center transition-colors flex items-center justify-center no-underline ${cartItems.length > 0
                    ? 'bg-[#FF8555] hover:bg-[#F06B35] text-white shadow-xs'
                    : 'bg-[#ECE4D8] text-[#A89A8C] pointer-events-none'
                    }`}
                >
                  Realizar pedido
                </a>
              )}
            </div>
          </div>
        </div>
      </Transition>
    </>
  );
}